"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _UIBanner = _interopRequireDefault(require("UIComponents/alert/UIBanner"));

var _LockedFeatureMessage = _interopRequireDefault(require("ui-addon-upgrades/_core/lockedFeature/LockedFeatureMessage"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _RequestSeatBannerWrapper = _interopRequireDefault(require("../common/components/RequestSeatBannerWrapper"));

var LockedFeatureBanner = function LockedFeatureBanner(props) {
  var className = props.className,
      style = props.style,
      titleText = props.titleText,
      condensed = props.condensed,
      upgradeData = props.upgradeData;
  var messageClass = (0, _classNames.default)(className, {
    'private-upgrades-message-condensed': condensed,
    'private-upgrades-message-expanded': !condensed
  });
  return _react.default.createElement(_UIBanner.default, {
    className: messageClass,
    titleText: titleText,
    style: style
  }, _react.default.createElement(_RequestSeatBannerWrapper.default, {
    upgradeData: upgradeData
  }, _react.default.createElement(_LockedFeatureMessage.default, (0, _extends2.default)({}, props, {
    linkUse: "link-on-dark"
  }))));
};

LockedFeatureBanner.propTypes = _upgradeDataPropsInterface.upgradeDataPropsInterface;
var _default = LockedFeatureBanner;
exports.default = _default;
module.exports = exports.default;